import HttpService from './HttpService';

export const LoadCustomerGeneralInfo = (id, signal) => {
    const http = new HttpService();
    let url = "customer/view-details/"+id;
    const tokenId = "user-token";
    
    return http.getDataAxiosBySignal(url, tokenId, signal).then(data => {
         return data;
    }).catch((error) => {
         return error; 
    });
}

export const LoadCompanyService= (id) => {
    const http = new HttpService();
    let url = "customer/company-details/"+id;
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const LoadApplicationTemplateService = (id) => {
    const http = new HttpService();
    let url = "customer/license/" + id+"/application-create";
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}

export const ConfigApplicaitonTemplateService = () => {
    const http = new HttpService();
    let url = "customer/license/application-type-config";
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const ConfigChalaniService = () => {
    const http = new HttpService();
    let url = "customer/chalani/chalani-config";
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}

export const ConfigService = () => {
    const http = new HttpService();
    let url = "customer/messanger/config";
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}
export const ListUsersByRoleService = (role, fieldsAssignment) => {
    const http = new HttpService();
    let url = "customer/messanger/users/" + role;
    const tokenId = "user-token";
    return http.postData(fieldsAssignment, url, tokenId).then((data) => {
        return data;
    }).catch((error) => {
        return error;;
    })
}


export const CustomerGeneralInfoStoreService = (credentials) => { 
    const http = new HttpService();
    let customerUpdateUrl = "customer/general-info-update";
    const tokenId = "user-token";
    return http.postFormData(credentials, customerUpdateUrl,tokenId).then((data) => {
    
        return data;
    }).catch((error) => {
        return error;;
    })

} 
export const CompanyStoreService = (credentials) => {
    const http = new HttpService();
    let customerUpdateUrl = "customer/company-store";
    const tokenId = "user-token";
    return http.postFormData(credentials, customerUpdateUrl, tokenId).then((data) => {

        return data;
    }).catch((error) => {
        return error;;
    })

}
export const ApplicationStoreService = (template,credentials) => {
    const http = new HttpService();
    let customerUpdateUrl = "customer/license/" + template + "/application-store";
    const tokenId = "user-token";
    return http.postFormData(credentials, customerUpdateUrl, tokenId).then((data) => {

        return data;
    }).catch((error) => {
        return error;;
    })

}
export const viewFileService = (item) => {
    const http = new HttpService();
    let url = "customer/view-file/"+item.id;
    const tokenId = "user-token";
    const fileExtension = item.file_extension;
    const contentType = item.content_type;
    
    return http.getDataFile(url, tokenId, contentType, fileExtension);
}

export const viewFileByIDService = (item) => {
    const http = new HttpService();
    let url = "customer/view-file-by-id/" + item;
    const tokenId = "user-token";

    return http.getDataAxios(url, tokenId).then(data => {
        return data;
    }).catch((error) => {
        return error;
    });
}